export const culture = window.__litium.culture.culture || 'sv-SE';